module.exports = __webpack_public_path__ + "media/images/home/produto_chuva_agora-275fc2297101e550bbc15795d1304502.png";